const shouldSkipSimulationNeeds = () => false;

export default shouldSkipSimulationNeeds;
